import { render, staticRenderFns } from "./OneStepUp.vue?vue&type=template&id=65dd714b&"
import script from "./OneStepUp.vue?vue&type=script&lang=js&"
export * from "./OneStepUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports